<rt-dropdown [width]="DropdownWidth.LargeX">
  <rt-form-field *ngIf="searchEnabled" padding-small-x>
    <rt-input
      [autoFocus]="true"
      [formControl]="searchFormControl"
      [placeholder]="'app.emoji.search' | translate"
      variant="rounded"
    >
      <rt-icon prefix name="search"></rt-icon>
    </rt-input>
  </rt-form-field>
  <div
    #virtualScrollerComponent
    (vsChange)="onChange($event)"
    (vsUpdate)="listUpdate($event)"
    [bufferAmount]="10"
    [enableUnequalChildrenSizes]="true"
    [executeRefreshOutsideAngularZone]="true"
    [items]="filteredEmojis"
    [style.height.px]="searchEnabled ? 244 : 288"
    [scrollDebounceTime]="30"
    [style.overflow-y]="isScrollAlwaysVisible ? 'scroll' : 'auto'"
    class="emoji-container"
    virtualScroller
  >
    <div
      *ngFor="let element of virtualScrollData; trackBy: trackByValue; let indexRow = index"
      [class.emoji-row]="FlatArrayItemType.EmojiRow === element.type"
    >
      <rt-dropdown-header *ngIf="FlatArrayItemType.Heading === element.type" [isSubheading]="true">
        {{ element.name | translate }}
      </rt-dropdown-header>

      <ng-container *ngIf="FlatArrayItemType.EmojiRow === element.type">
        <span
          (click)="select(emoji)"
          (mouseenter)="onMouseEnter(indexRow + startIndexWithBuffer, indexCol)"
          *ngFor="let emoji of element.data; trackBy: trackByName; let indexCol = index"
          [class.active]="indexRow + startIndexWithBuffer === activeRow && indexCol === activeCol"
          title=":{{ emoji.shortName }}:"
          class="emoji-container"
        >
          <rt-emoji [emoji]="emoji.symbol" [size]="24"></rt-emoji>
        </span>
      </ng-container>
    </div>
  </div>
</rt-dropdown>
